import { useTranslation } from 'react-i18next';

import useVisibleTabs from './hooks/useVisibleTabs';

import NoDataPlaceholder from 'components/shared/NoDataPlaceholder';
import TabsView from './TabsView';

import type { FC } from 'react';
import type { Header, TabType } from './types';

interface Props {
  page: string;
  headers: Header[];
  views: TabType[];
  userGrantNeeded: string;
}

const BaseTabsRouting: FC<Props> = ({
  page,
  headers,
  views,
  userGrantNeeded
}) => {
  'use memo';

  const { t } = useTranslation('common');
  const { filteredHeaders, filteredViews } = useVisibleTabs(headers, views);

  // Every header is behind a grant this user does not have, so there is no tab to
  // open and nothing to route to. Guarding here rather than inside the screen keeps
  // the rest of it free of "what if there is no header": `useTabNavigation` needs a
  // header and a view to start from, and the toolbar indexes into both.
  if (!filteredHeaders.length) {
    return (
      <NoDataPlaceholder
        title={t('noAccessPage.description')}
        icon="box-open"
      />
    );
  }

  return (
    <TabsView
      page={page}
      headers={filteredHeaders}
      views={filteredViews}
      configuredViews={views}
      userGrantNeeded={userGrantNeeded}
    />
  );
};

export default BaseTabsRouting;
